// extracted by mini-css-extract-plugin
export default {"bar":"sectionTabs_bar__hZ2Ld","tab":"sectionTabs_tab__v1nSY","active":"sectionTabs_active__lludm"};